export { isIE as default } from 'choerodon-ui/lib/_util/browser';
